module.exports = __webpack_public_path__ + "static/reverse-statue-of-liberty-125e8bb057365cb1840f303d4e27817e.jpg";